import { DetailedBet } from '@/models/detailed-bet';
import { LiveBetActions, AddBetPayload } from './props';

export function addLiveBet(bet: DetailedBet): AddBetPayload {
  return { type: LiveBetActions.AddBet, payload: bet };
}
